import React, { useId } from "react";
import {
  FieldErrors,
  FieldName,
  FieldValues,
  Path,
  useFormContext,
} from "react-hook-form";
import Error from "../Error";
import Label from "./Label";
import {
  ErrorMessage,
  FieldValuesFromFieldErrors,
} from "@hookform/error-message";
import InfoPopover from "../../InfoPopover";

type props<t extends FieldValues> = {
  name: Path<t>;
  label?: string;
  optional?: boolean;
  hint?: React.ReactNode;
} & React.InputHTMLAttributes<HTMLInputElement>;

const Input = <t extends FieldValues>({
  name,
  optional,
  className,
  label,
  hint,
  ...otherProps
}: props<t>) => {
  const id = useId();
  const { register, formState } = useFormContext<t>();
  return (
    <div className={className}>
      <Label optional={optional} htmlFor={id}>
        {label}
      </Label>
      <input
        id={id}
        {...register(name, { valueAsNumber: otherProps.type === "number" })}
        className="input-text-style input-box-style"
        {...otherProps}
      />
      {hint && <p className="hint my-1">{hint}</p>}

      <ErrorMessage
        errors={formState.errors}
        name={name as FieldName<FieldValuesFromFieldErrors<FieldErrors<t>>>}
        render={({ message }) => <Error>{message}</Error>}
      />
    </div>
  );
};

export default Input;
